import DeafaultImg from '@Assets/images/coming-soon.jpg';
import ConstantsMod from '@Constants/index.constants.js';
/** @typedef {import('./Utility.svc')} Types */
export class Utility {
	constructor($timeout, $window, DEFAULT_IMG, $log, $location, $anchorScroll) {
		'ngInject';
		this.timeout = $timeout;
		this.log = $log;
		this.window = $window;
		this.location = $location;
		this.anchorScroll = $anchorScroll;
		this.defaultImg = DEFAULT_IMG;
	}

	/**
	 * @param {string} id
	 * @returns {void}
	 */
	focus(id) {
		this.timeout(() => {
			const element = this.window.document.getElementById(id);
			if (element) {
				element.focus();
			}
		}, 100);
	}

	/**
	 * @param {any} argument
	 * @returns {any}
	 */
	causeError(argument) {
		foo();
		function foo() {
			bar();
		}
		function bar() {
			// eslint-disable-next-line
			var x = y; // NOTE: "y" is undefined.
		}
		return argument;
	}

	/**
	 * @param {string} className
	 * @returns {{height: string}}
	 */
	calculateMaxHeight(className) {
		const elemList = this.window.document.getElementsByClassName(className);
		var maxHeight = 0;
		for (let i = 0; i < elemList.length; i++) {
			if (elemList[i].clientHeight > maxHeight) {
				maxHeight = elemList[i].clientHeight;
			}
		}
		return {height: `${maxHeight}px`};
	}

	/**
	 * @param {string|number} value
	 * @returns {number}
	 */
	parseIntIfString(value) {
		return typeof value === 'string' ? parseInt(value) : value;
	}

	/**
	 * @param {'width'|'height'} side
	 * @param {string} className
	 * @returns {number}
	 */
	maxElm(side, className) {
		const _sideMethod = side === 'width' ? 'scrollWidth' : 'scrollHeight';
		const _elemList = this.window.document.getElementsByClassName(className);
		let _max = 0;
		for (let i = 0; i < _elemList.length; i++) {
			if (_elemList[i][_sideMethod] > _max) {
				_max = _elemList[i][_sideMethod];
			}
		}
		return _max;
	}

	/** @returns {string} */
	uuid() {
		function s4() {
			return Math.floor((1 + Math.random()) * 0x10000)
				.toString(16)
				.substring(1);
		}
		return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	}

	/**
	 * @param {string} origUrl
	 * @param {number} wid
	 * @param {number} hei
	 * @param {boolean} [fmt]
	 * @returns {string}
	 */
	generateImageVersion(origUrl, wid, hei, fmt) {
		// FIX: const _urlValue = origUrl || this.defaultImg;
		const _urlValue = origUrl || DeafaultImg;
		let _url = _urlValue.replace(/wid=(\d+)/, 'wid=' + wid).replace(/hei=(\d+)/, 'hei=' + hei);
		if (fmt === true) _url = _url.replace(/&defaultImage/, '&fmt=png-alpha&defaultImage');
		return _url;
	}

	/** @returns {string} */
	getRootDomain() {
		var parts = this.window.document.domain.split('.');
		if (parts.length > 2) {
			parts.shift();
		}
		return parts.join('.');
	}

	/** @returns {boolean} */
	areCookiesEnabled() {
		let cookieEnabled = navigator.cookieEnabled;
		if (!cookieEnabled) {
			this.window.document.cookie = 'testCookie';
			cookieEnabled = this.window.document.cookie.indexOf('testCookie') !== -1;
		}
		return cookieEnabled;
	}

	/**
	 * @param {string} systemName
	 * @returns {string|false}
	 */
	systemTypeUnit(systemName) {
		const systemTypesUnits = [
			{
				systems: ['furnace_with_evaporator_coil', 'gas_boiler', 'gas_furnace'],
				unit: 'BTU',
			},
			{
				systems: ['water_heater'],
				unit: 'Gal',
			},
			{
				systems: [
					'ductless',
					'evaporator_coil',
					'fan_coil',
					'heat_pump_with_evaporator_coil',
					'heat_pump_without_air_handler',
					'heat_pump',
					'hybrid_heat_pump',
					'packaged_unit',
					'straight_cool_existing_furnace',
					'straight_cool_plus_furnace_only',
					'straight_cool_plus_furnace',
					'straight_cool_without_air_handler',
					'straight_cool',
					'single_zone_ductless',
					'indoor_ductless_unit',
				],
				unit: 'Ton',
			},
		];

		const groupOfSystemTypes = systemTypesUnits.filter(group => group.systems.indexOf(systemName) !== -1);
		const unit = groupOfSystemTypes.length > 0 ? groupOfSystemTypes[0].unit : false;

		if (!unit) this.log.warn(`Not unit type for system type: ${systemName}.`);
		return unit;
	}

	/**
	 * @param {unknown[]} totalItems
	 * @returns {number}
	 */
	columnFactor(totalItems) {
		const baseColWidth = 4;
		const total = totalItems.length;
		return total < baseColWidth || total === 6 ? 3 : baseColWidth;
	}

	/**
	 * @param {string} str
	 * @returns {boolean}
	 */
	isValidJson(str) {
		try {
			JSON.parse(str);
		} catch (e) {
			this.log.warn(e);
			return false;
		}
		return true;
	}

	/**
	 * @param {any[]} collection
	 * @param {unknown} attrValue
	 * @param {string} attrName
	 * @param {unknown} [fallback]
	 * @returns {Types.SearchInCollectionResult}
	 */
	searchInCollection(collection, attrValue, attrName, fallback) {
		var result = {res: null, fall: null};
		for (let i = 0; i < collection.length; i++) {
			if (collection[i][attrName] === attrValue) {
				result.res = collection[i];
			}
			if (fallback) {
				if (collection[i][attrName] === fallback) {
					result.fall = collection[i];
				}
			}
		}
		return result;
	}

	/**
	 * @param {any[]} collection
	 * @param {string} key
	 * @param {unknown} value
	 * @returns {number|null}
	 */
	findIndexByValueInKey(collection, key, value) {
		let idx = null;
		for (let i = 0; i < collection.length; i++) {
			if (collection[i][key] === value) {
				idx = i;
				break;
			}
		}
		return idx;
	}

	/**
	 * @param {string[]} keys
	 * @param {Record<string, unknown>} obj
	 * @returns {boolean}
	 */
	validateKeysInObject(keys, obj) {
		let _msg = `The alternateProductModal component require keys: `;
		const _isValid = Object.keys(obj).reduce((acc, curr) => {
			if (keys.indexOf(curr) === -1) {
				_msg += `${curr} `;
				return false;
			}
			return acc;
		}, true);
		if (!_isValid) this.log.error(_msg);
		return _isValid;
	}

	/**
	 * @param {any[]} arr
	 * @param {string} attr
	 * @param {unknown} val
	 * @returns {any|undefined}
	 */
	getObjByAttrValue(arr, attr, val) {
		let _obj;
		for (let i = 0; i < arr.length; i++) {
			if (arr[i][attr] === val) {
				_obj = arr[i];
				break;
			}
		}
		return _obj;
	}

	/**
	 * @param {string} id
	 * @returns {void}
	 */
	gotoAnchor(id) {
		if (!id) this.log.warn('Element id is required to scroll to');
		this.timeout(() => {
			this.location.hash(id);
			this.anchorScroll();
		}, 500);
	}

	/**
	 * @param {any[]} collection
	 * @param {string} attr
	 * @returns {unknown[]}
	 */
	makeArrayOfAttrValues(collection, attr) {
		const newArray = [];
		collection.forEach(item => {
			newArray.push(item[attr]);
		});
		return newArray;
	}

	/**
	 * @param {any[]} collection
	 * @returns {any[]}
	 */
	getUniqueObjects(collection) {
		return collection.filter(
			(item, index) => index === collection.findIndex(obj => JSON.stringify(obj) === JSON.stringify(item))
		);
	}

	/**
	 * @param {Record<string, unknown>} obj
	 * @returns {Record<string, unknown>}
	 */
	flattenObj(obj) {
		const result = {};
		for (const [key, val] of Object.entries(obj)) {
			if (val && typeof val === 'object' && !Array.isArray(val)) {
				Object.assign(result, val);
			} else {
				result[key] = val;
			}
		}

		return result;
	}
}
//
let compMod = angular.module('mod.svc.UtilitySvc', [ConstantsMod]).service('UtilitySvc', Utility);
export default (compMod = compMod.name);
